// Planning maths for EPM — pure functions, no I/O (02-SOFTWARE-DESIGN §5).

// Inverse standard normal CDF (Acklam's rational approximation, |error| < 1.2e-9)
const inverseNormal = (p) => {
    const a = [-39.69683028665376, 220.9460984245205, -275.9285104469687, 138.357751867269, -30.66479806614716, 2.506628277459239];
    const b = [-54.47609879822406, 161.5858368580409, -155.6989798598866, 66.80131188771972, -13.28068155288572];
    const c = [-0.007784894002430293, -0.3223964580411365, -2.400758277161838, -2.549732539343734, 4.374664141464968, 2.938163982698783];
    const d = [0.007784695709041462, 0.3224671290700398, 2.445134137142996, 3.754408661907416];
    const low = 0.02425;
    if (p < low) {
        const q = Math.sqrt(-2 * Math.log(p));
        return (((((c[0] * q + c[1]) * q + c[2]) * q + c[3]) * q + c[4]) * q + c[5]) / ((((d[0] * q + d[1]) * q + d[2]) * q + d[3]) * q + 1);
    }
    if (p > 1 - low) return -inverseNormal(1 - p);
    const q = p - 0.5;
    const r = q * q;
    return (((((a[0] * r + a[1]) * r + a[2]) * r + a[3]) * r + a[4]) * r + a[5]) * q / (((((b[0] * r + b[1]) * r + b[2]) * r + b[3]) * r + b[4]) * r + 1);
};

/**
 * Visitors needed per variant to detect a relative lift of `mde` on a
 * conversion rate of `baseline` (two-proportion z-test).
 * `mde` and `baseline` are fractions: 0.03 = 3%.
 */
export const requiredSampleSize = ({ baseline, mde, alpha = 0.05, power = 0.8, tails = 2 }) => {
    const p1 = baseline;
    const p2 = baseline * (1 + mde);
    const zAlpha = inverseNormal(1 - alpha / tails);
    const zPower = inverseNormal(power);
    const variance = p1 * (1 - p1) + p2 * (1 - p2);
    return Math.ceil(((zAlpha + zPower) ** 2 * variance) / (p2 - p1) ** 2);
};

/** Calendar days to reach the sample, with traffic split evenly across variants. */
export const durationDays = ({ perVariant, dailyTraffic, variants = 2 }) =>
    Math.ceil((perVariant * variants) / dailyTraffic);

/** Days at each MDE (in percent) across a range — powers the planning curve. */
export const durationCurve = ({ baseline, dailyTraffic, alpha, power, tails, from = 1, to = 10, step = 0.1 }) => {
    const points = [];
    for (let mdePct = from; mdePct <= to + 1e-9; mdePct += step) {
        const perVariant = requiredSampleSize({ baseline, mde: mdePct / 100, alpha, power, tails });
        points.push({ mde: Number(mdePct.toFixed(2)), days: durationDays({ perVariant, dailyTraffic }) });
    }
    return points;
};
